import styled from 'styled-components';
import { COLORS, FONTS } from '@stelecom/ui-react/assets/js/constants';
import { breakpoints } from '~/src/layout/index/styled';

export const LinksTitle = styled.div` 
    font-size: 16px;  
    line-height: 22px;  
    ${FONTS.S};  
    color: ${COLORS.blueDark};
    margin-bottom: 18px;
`;

export const LinksList = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 100px;
  width: 100%;
`;


export const LinkFooter = styled.a`
    font-size: 13px;
    line-height: 18px;
    color: ${COLORS.grey};
    margin-bottom: 12px;
    width: max-content;
    transition: color .3s ease-in-out,background .3s ease-in-out,opacity .3s ease-in-out;
  
    &:last-child{
        margin-bottom: 0;
        height: 50px;
        
        @media(max-width: 950px){
            height: 20px;
        }
    }
    
    &:hover{
      cursor: pointer;
      color: ${COLORS.PINK_BRIGHT};
    }

    @media(max-width: 916px){
      height: 20px;
      width: 100%;
    }
`;

export const MainLinksBlock = styled.div`
    flex-direction: column;
`;

export const LinksBlock = styled(MainLinksBlock)`
  height: 100%;
  display: flex;
  

    width: 49%;
    
    @media (max-width: ${breakpoints.mobile}){
        width: 100%;
    }

`;
